import { IRedirect } from '@/models/redirects.model';
import { ColumnsType } from 'antd/es/table';
import { TFunction } from 'react-i18next';
import TableActions from '../TableActions/TableActions';

type TGetTableColumns = {
  t: TFunction;
  onDelete: (item: IRedirect) => void;
  onEdit: (item: IRedirect) => void;
  canManage: boolean;
};

export const getRedirectsTableColumns = ({
  t,
  onDelete,
  onEdit,
  canManage,
}: TGetTableColumns): ColumnsType<IRedirect> => [
  {
    title: t('redirect_status_code'),
    dataIndex: 'type',
    key: 'type',
  },
  {
    title: t('redirect_from'),
    dataIndex: 'source',
    key: 'source',
  },
  {
    title: t('redirect_to'),
    dataIndex: 'target',
    key: 'target',
  },
  ...(canManage
    ? [
        {
          title: t('redirect_actions'),
          key: 'actions',
          render: (_: unknown, record: IRedirect) => (
            <TableActions record={record} onEdit={onEdit} onDelete={onDelete} />
          ),
        },
      ]
    : []),
];
